import { TableOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { useEditor } from '@eastcoal/editor/hooks/useEditor'

import { INSERT_TABLE_VARIABLE_COMMAND } from '../../../../editor/plugins/TableVariablePlugin/commands'

import { TableVariableButtonProps } from './interface'

export const TableVariableButton = ({ data }: TableVariableButtonProps) => {
  const editor = useEditor()
  const handleClick = () => {
    editor.dispatchCommand(INSERT_TABLE_VARIABLE_COMMAND, {
      variable: {
        id: data.id,
        name: data.name,
        property: data.property,
        description: data.description,
        // 默认显示前 5 个字段
        children: (data.children || []).slice(0, 5).map(item => {
          return {
            id: item.id,
            name: item.name,
            property: item.property,
            description: item.description
          }
        })
      }
    })
  }

  return (
    <Button icon={<TableOutlined />} onClick={handleClick}>
      {data.name}
    </Button>
  )
}
